import React from 'react'
import { Link } from 'react-router-dom'
import { LBFooter, LBButton } from '@linearb/buzz'
import { APP_URL } from '../constants/apis'
import { behindLabel, CURRENT_VERSION } from '../lib/appVersion'
import { reloadForUpdate, useLatestVersion } from '../hooks/useVersionCheck'

interface DashboardLayoutProps {
  children: React.ReactNode
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const { latestVersion, behind } = useLatestVersion()

  return (
    <div
      className='bg-muted p-0 md:p-6 flex flex-col'
      style={{ minHeight: 'calc(100vh - 48px)' }}
    >
      <div className='bg-card md:rounded-lg md:shadow-sm md:border md:border-border p-3 md:p-6 flex-1'>
        {children}
      </div>
      <LBFooter className='mt-4 shrink-0 flex-col md:flex-row items-center md:justify-between gap-2'>
        <span className='text-sm text-muted-foreground text-center'>
          © LinearB Inc. 2025. All rights reserved.
          {CURRENT_VERSION && (
            <span className='ml-2 font-mono text-xs opacity-50'>
              · {CURRENT_VERSION}
            </span>
          )}
          {behind > 0 && (
            <LBButton
              variant='link'
              className='ml-2 p-0 h-auto text-xs'
              onClick={() => reloadForUpdate(latestVersion, behind)}
            >
              {behindLabel(behind)}
            </LBButton>
          )}
        </span>
        <div className='flex items-center gap-2'>
          <LBButton asChild variant='link'>
            <Link to='/changelog'>Changelog</Link>
          </LBButton>
          <LBButton asChild variant='link'>
            <a
              href={APP_URL}
              target='_blank'
              rel='noopener noreferrer'
            >
              Go to LinearB
            </a>
          </LBButton>
        </div>
      </LBFooter>
    </div>
  )
}

export default DashboardLayout
